import React, { useEffect, useState, useRef } from 'react';
import ApiService from '../../services/apiService';
import { RxCross1 } from "react-icons/rx";

const DirectItemsView = ({ onRequisitionData, itemData, setLazyLoading, currencyPrecision, isXtreamCompany }) => {
    const [itemRows, setItemRows] = useState([]);
    const apiService = new ApiService();

    useEffect(() => {
        const getItems = async () => {
            try {
                if (itemData?.issueDetails && itemData.issueDetails.length > 0) {
                    const formattedRowsPromises = itemData?.issueDetails.map(async (detail, index) => {
                        return {
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail?.qty,
                            uom: detail?.uom,
                            baseQty: detail?.qty * 1,
                            conValue: detail?.convToInvUOM,
                            unitPrice: detail?.unitPrice,
                            specification: detail.specification,
                            amount: detail?.unitPrice * detail?.qty,
                            stock: detail?.stock,
                            cgsAcc: detail.cgsAccountCode,
                            cgsAccName: detail.cgsAccountName,
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsPromises);
                    setItemRows(formattedRows);
                    setLazyLoading(false)
                }
            } catch (error) {
                console.error('Error fetching items:', error);
                setLazyLoading(false)
            }
        };
        if (itemData) {
            getItems();
        }

    }, [itemData]);

    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            <table>
                <thead className='dynoTable'>
                    <tr>
                        <th></th>
                        <th>Sr no</th>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Item Specs</th>
                        <th>Inventory UOM</th>
                        <th>Qty</th>
                        <th>Inventory Qty</th>
                        {isXtreamCompany === true ? "" : <th>Stock</th>}
                        <th>Unit Price</th>
                        <th>Amount</th>
                        <th>CGS Acc </th>
                        <th>CGS Acc Name </th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(itemRows) && itemRows.map((row, index) => (
                        <tr key={index}>
                            <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)", cursor: "not-allowed" }}>
                                <div className='center'>
                                    <RxCross1 size={25} disabled />
                                </div>
                            </td>
                            <td className='m-0 p-0'><input className='p-2' type="text" style={{ width: "80px" }} value={row.srno} disabled /></td>
                            <td className='m-0 p-0 itemCol'>
                                <input className='p-2' type='text' disabled value={row?.itemNo} />
                            </td>
                            <td className='m-0 p-0 descriptionCol'>
                                <input className='p-2' disabled value={row.itemDescription} style={{ width: "100%" }} />
                            </td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.uom} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.qty} style={{ width: "100px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" style={{ width: "130px" }} value={row.baseQty} /></td>
                            {isXtreamCompany === true ? "" :
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.stock || ""} style={{ width: "130px" }} /></td>
                            }
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.unitPrice || 0).toFixed(currencyPrecision || 0)} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.amount).toFixed(currencyPrecision || 0)} style={{ width: "120px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.cgsAcc} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.cgsAccName} style={{ width: "130px" }} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DirectItemsView;